/**
 * Base css generation and global js logic
 */

import $ from 'jquery';
import './_base.scss';
import {
  objectFitFallback,
  isIE,
  transformSuperscript,
  smoothAnchorScroll,
} from 'protons/utilities';

if (isIE()) {
  objectFitFallback();
}

transformSuperscript();

$('a[href^="#"]').on('click', e => {
  const $target = $(e.currentTarget).attr('href');
  smoothAnchorScroll($target);
});

export default {};
